<template>
  <page>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">

      <!-- BEGIN: Subheader -->
      <div class="m-subheader ">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <h1 class="m-subheader__title ">Zmień e-mail</h1>
          </div>
        </div>
      </div>
      <!-- END: Subheader -->
      <div class="m-content">
        <div class="m-portlet m-portlet--full-height  ">
          <div class="tab-content">
            <div class="">
              <div class="m-form m-form--fit m-form--label-align-right">
                <div class="m-portlet__body">
                  <div class="form-group m-form__group row">
                    <label for="new-email" class="col-5 col-md-2 col-form-label">Nowy e-mail</label>
                    <div class="col-7">
                      <b-form-input id="new-email" type="email"
                                    v-model="newEmail"></b-form-input>
                    </div>
                  </div>
                  <div class="form-group m-form__group row">
                    <label for="current-password" class="col-5 col-md-2 col-form-label">Obecne hasło</label>
                    <div class="col-7">
                      <b-form-input id="current-password" :state="currentPasswordState" type="password"
                                    aria-describedby="currentPasswordFeedback"
                                    v-model="currentPassword"></b-form-input>
                      <b-form-invalid-feedback id="currentPasswordFeedback">
                        Musisz podać obecne hasło
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </div>
                <div class="m-portlet__foot m-portlet__foot--fit">
                  <div class="m-form__actions">
                    <div class="row">
                      <div class="col-12">
                        <button class="btn btn-ls m-btn m-btn--air"
                                :disabled="disabled"
                                @click="updateEmail">Zapisz zmiany
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import EmailValidator from 'email-validator';
import {mapState} from 'vuex';
import Page from "./Page";
import debounce from 'lodash.debounce'

export default {
  name: "ChangeEmailPage",
  components: {Page},
  data() {
    return {
      currentPassword: '',
      newEmail: '',
      disabled: false,
    }
  },
  beforeMount() {
    if (!this.isProfileEditEnabled) {
      this.$router.push({name: 'ProfilePage'})
    }
  },
  methods: {
    updateEmail: debounce(function () {
      if (!this.currentPassword.length || !this.newEmail.length) {
        this.$notify.danger('Wypełnij formularz.');
        return;
      }

      if (this.validation) {
        this.$notify.danger('Popraw formularz.');
        return;
      }
      this.disabled = true;

      this.$http.post('email/change', {
        currentPassword: this.currentPassword,
        newEmail: this.newEmail
      })
          .then(() => {
            this.currentPassword = '';
            this.newEmail = '';
          })
          .finally(() => setTimeout(() => this.disabled = false, 800))
    }, 300)
  },
  computed: {
    currentPasswordState() {
      if (!this.currentPassword.length && this.newEmail.length) {
        return false
      }

      if (!this.currentPassword.length) {
        return null
      }

      return true
    },
    validation() {
      return !(this.currentPasswordState === true && EmailValidator.validate(this.newEmail))
    },
    ...mapState({
      isProfileEditEnabled: state => state.settings.disableProfileEdit === '0'
    })
  }
}
</script>

<style scoped>
@media (max-width: 769px) {
  .m-form__group {
    padding-bottom: 0 !important;
  }
}
</style>
